import React, { createContext } from 'react';
type PropsT = {
  setItemInStorage: (key: string, value: string, isPersistent: boolean) => void;
  getItemFromStorage: (key: string, isPersistent: boolean) => string;
  children: React.ReactNode;
};
type StorageT = {
  set: (key: string, value: string) => void;
  get: (key: string) => string;
};
export const StorageContext = createContext<StorageT>({
  set: (_key: string, _value: string) => {},
  get: (_key: string) => ''
});
export const StorageProvider = ({
  setItemInStorage,
  getItemFromStorage,
  children
}: PropsT) => {
  const isPersistent = true;
  const set = (key: string, value: string) => {
    setItemInStorage(key, value, isPersistent);
  };
  const get = (key: string) => {
    return getItemFromStorage(key, isPersistent);
  };
  return <StorageContext.Provider value={{
    get,
    set
  }}>
      {children}
    </StorageContext.Provider>;
};